import angular from 'angular';

export function WebAppRouteService(EnvSettings) {
    const openPage = (url, isNewPage) => {
        window.open(url, isNewPage ? '_blank' : '_self');
    };

    const goToViewJobPage = ({ employerId, positionId }, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/position/${positionId}/view`;

        openPage(url, isNewPage);
    };

    const goToViewUploadWizardPage = ({ employerId, positionId, stepName }, isNewPage = false) => {
        let url = `${EnvSettings.WebAppUrl}/employer/${employerId}/position/${positionId}/wizard/${stepName}`;

        if (stepName === 'create') {
            url = `${EnvSettings.WebAppUrl}/employer/${employerId}/position/wizard/${stepName}`;
        }

        openPage(url, isNewPage);
    };

    const goToEmployerCandidatesPage = ({ employerId, positionId, workflowStep, filter = '' }, isNewPage = false) => {
        const filterQuery = filter ? `?filter=${filter}` : '';
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/position/${positionId}/workflowStep/${workflowStep}/candidates${filterQuery}`;

        openPage(url, isNewPage);
    };

    const goToEmployerCandidatePage = ({ employerId, positionId, workflowStep, talentId, talentID, filter = '' }, isNewPage = false) => {
        const filterQuery = filter ? `?filter=${filter}` : '';
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/position/${positionId}/workflowStep/${workflowStep}/candidates/${talentId || talentID}${filterQuery}`;

        openPage(url, isNewPage);
    };

    const goToPositionDescriptionPage = ({ positionId }, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/public/position-description/${positionId}`;

        openPage(url, isNewPage);
    };

    const goToCampaignCreditsPage = ({ employerId }, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/jobCredits`;

        openPage(url, isNewPage);
    };

    const goToCampaignsActivityPage = ({ employerId }, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/campaignsActivity`;

        openPage(url, isNewPage);
    };

    const goToPSSCampaignsActivityPage = ({ employerId }, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/pcCampaignsActivity`;

        openPage(url, isNewPage);
    };

    const goToManageEmployerRepDetails = ({ employerId }, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/manageUsers`;

        openPage(url, isNewPage);
    };

    const goToDiversityOptimizerPage = ({ employerId, positionId}, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/position/${positionId}/diversity-optimizer`;
        openPage(url, isNewPage);
    };

    const goPositionsPage = ({ employerId }, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/positions`;
        openPage(url, isNewPage);
    };

    const goPositionEditPage = ({ employerId, positionId}, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/position/${positionId}/view`;
        openPage(url, isNewPage);
    };

    const goDiversityReportPage = ({ employerId }, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/diversityReport`;
        openPage(url, isNewPage);
    };

    const goToEmployerCampaignsPage = ({ employerId }, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/employerCampaigns`;
        openPage(url, isNewPage);
    };

    const goToSystemCampaignPage = ({ campaignId, employerId }, isNewPage = false) => {
        const url = `${EnvSettings.WebAppUrl}/employer/${employerId}/system/campaign/${campaignId}`;
        openPage(url, isNewPage);
    };

    return {
        openPage,
        goToDiversityOptimizerPage,
        goToViewJobPage,
        goToViewUploadWizardPage,
        goToEmployerCandidatesPage,
        goToEmployerCandidatePage,
        goToPositionDescriptionPage,
        goToCampaignCreditsPage,
        goToCampaignsActivityPage,
        goToPSSCampaignsActivityPage,
        goToManageEmployerRepDetails,
        goPositionEditPage,
        goDiversityReportPage,
        goPositionsPage,
        goToEmployerCampaignsPage,
        goToSystemCampaignPage,
    };
}

angular.module('TALENYA-FE').factory('WebAppRouteService', WebAppRouteService);
